// extracted by mini-css-extract-plugin
export default {"ChangelogItem":"changelog-item_ChangelogItem__Q2ZZn"};